// extracted by mini-css-extract-plugin
module.exports = {"base":"hero_base__bdOeB","left":"hero_left__4FJVj","right":"hero_right___pRm0","imgLeftWrapper":"hero_imgLeftWrapper__tlAGY"};